import {
  BookingInput,
  BookingResourceBookingSlot,
  BookResourceScreenDocument,
  BookSlottedResourceDocument,
  CancelSlottedBookingDocument,
  ProfileInput,
  ScreenProfile,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const bookResourceScreen = async (
  participants: ProfileInput[],
  booking: BookingInput
) => {
  const response = await apolloClient.mutate({
    mutation: BookResourceScreenDocument,
    variables: {
      participants,
      booking,
    },
    errorPolicy: 'all',
  });

  if (response.data?.booking?.saveBooking?.success) {
    return response.data.booking.saveBooking;
  }

  throw new SentryGraphQLError(`api.booking.bookResourceScreen`, response);
};

const bookSlottedResource = async (
  participants: ProfileInput[],
  bookingSlot: BookingResourceBookingSlot
) => {
  const response = await apolloClient.mutate({
    mutation: BookSlottedResourceDocument,
    variables: {
      participants,
      bookingSlot,
    },
    errorPolicy: 'all',
  });

  if (response.data?.booking?.saveSlottedBooking?.success) {
    return response.data.booking.saveSlottedBooking;
  }

  throw new SentryGraphQLError(`api.booking.bookSlottedResource`, response);
};

const cancelSlottedBooking = async (
  profile: ScreenProfile,
  bookingSlot: BookingResourceBookingSlot
) => {
  const response = await apolloClient.mutate({
    mutation: CancelSlottedBookingDocument,
    variables: {
      profile,
      bookingSlot,
    },
    errorPolicy: 'all',
  });

  if (response.data?.booking?.cancelSlottedBooking?.success) {
    return response.data.booking.cancelSlottedBooking;
  }

  throw new SentryGraphQLError(`api.booking.cancelSlottedBooking`, response);
};

export default {
  bookResourceScreen,
  bookSlottedResource,
  cancelSlottedBooking,
};
